const getToken = (state) => {
  try {
    return state.token;
  } catch (e) {
    return undefined;
  }
};

const getRut = (state) => {
  try {
    return state.rut;
  } catch (e) {
    return undefined;
  }
};

const getDv = (state) => {
  try {
    return state.dv;
  } catch (e) {
    return undefined;
  }
};

const getNames = (state) => {
  try {
    return state.names;
  } catch (e) {
    return undefined;
  }
};

const getIdRefAddress = (state) => {
  try {
    return state.idRefAddress;
  } catch (e) {
    return undefined;
  }
};

const getData = (state) => {
  try {
    return state;
  } catch (e) {
    return undefined;
  }
};

export default {
  getToken,
  getData,
  getRut,
  getDv,
  getIdRefAddress,
  getNames,
};
